import { Link, StyleSheet, View } from '@react-pdf/renderer'
import { Image } from '@ulysses-inc/harami_api_client'
import React from 'react'
import BreakText from 'src/features/reports/result/downloadPDF/BreakText'
import Grid from 'src/features/reports/result/downloadPDF/Grid'
import ReactPDFImage from 'src/features/reports/result/downloadPDF/ReactPDFImage'
import RecordedTime from './RecordedTime'

interface OwnProps {
  questionName: string
  questionInformation?: Image
  answerInformation?: Image
  recordedAt?: Date
  isTimeDisplayed: boolean
}

const styles = StyleSheet.create({
  gridInformation: { width: '100%' },
  image: {
    width: '50%',
    height: 140,
    objectFit: 'contain',
    left: 1,
  },
  recordedTimeWrap: { width: '100%', marginBottom: 5 },
  fullWidthWrap: { width: '100%' },
})

// PDFならサムネイルURLと判定を返す共通関数
const getThumbInfo = (img?: Image) => {
  if (!img?.url) return { url: '', isPDF: false }
  const ext = img.url.split('.').pop()
  const isPDF = ext === 'pdf'
  const url = isPDF ? img.url.replace('.pdf', '.png') : img.url
  return { url, isPDF }
}

const Information: React.FC<OwnProps> = (props: OwnProps) => {
  const answer = props.answerInformation
  const question = props.questionInformation
  const ansThumb = getThumbInfo(answer)
  const quesThumb = getThumbInfo(question)

  // 表示対象の情報（answer優先、なければquestion）を決定
  const info = answer?.url
    ? {
        url: answer.url,
        thumbUrl: ansThumb.url,
        name: answer.name,
        isPDF: ansThumb.isPDF,
      }
    : question?.url
      ? {
          url: question.url,
          thumbUrl: quesThumb.url,
          name: question.name,
          isPDF: quesThumb.isPDF,
        }
      : null

  return (
    <Grid borderLeft borderRight style={styles.gridInformation}>
      <View style={styles.fullWidthWrap}>
        <BreakText text={props.questionName} />
        {info && (
          <View wrap={false}>
            {info.isPDF && (
              <Link src={info.url} style={{ marginLeft: 5 }}>
                {info.name}
              </Link>
            )}
            <ReactPDFImage style={styles.image} uri={info.thumbUrl} />
          </View>
        )}
        <View style={styles.recordedTimeWrap}>
          <RecordedTime
            isTimeDisplayed={props.isTimeDisplayed}
            recordedAt={props.recordedAt}
          />
        </View>
      </View>
    </Grid>
  )
}

export default Information
